import * as Joi from 'joi';
import { BackgroundFormatTypes, ChartVizPropVersion, ConditionalFormattingComparisonTypes, HandleMissingValues, LegendPositionOptions, Operators, } from '../../types/prism';
import { AxisPropertiesSchema } from './v2';
import { ChartPropertiesSchemaV4dot1, ChartSpecificObjectSchemaV4dot1, ClientStateV4dot1Props, } from './v4dot1';
const ChartSpecificObjectSchemaV4dot2 = {
    ...ChartSpecificObjectSchemaV4dot1,
    dataFieldArea: Joi.string().allow(null),
    showPivotSummaryPrior: Joi.string().allow(null),
    pivotSummariesState: Joi.object({
        __typename: Joi.string()
            .valid('PivotSummariesState')
            .allow(null),
        showRowTotals: Joi.boolean().allow(null),
        showColumnTotals: Joi.boolean().allow(null),
        showRowGrandTotals: Joi.boolean().allow(null),
        showColumnGrandTotals: Joi.boolean().allow(null),
    }).allow(null),
};
const ChartPropertiesSchemaV4dot2 = Joi.object({
    ...ChartPropertiesSchemaV4dot1,
    chartSpecific: Joi.object(ChartSpecificObjectSchemaV4dot2)
        .pattern(/\d/, Joi.any())
        .allow(null),
    mapviewport: Joi.object({
        __typename: Joi.string().valid('MapViewport'),
        center: Joi.array()
            .length(2)
            .items(Joi.number()),
        zoomLevel: Joi.number(),
        extent: Joi.array()
            .length(4)
            .items(Joi.number())
            .allow(null),
    }).allow(null),
    showLegend: Joi.boolean().allow(null),
    legendPosition: Joi.string()
        .valid(LegendPositionOptions.RightLegend, LegendPositionOptions.LeftLegend, LegendPositionOptions.TopLegend, LegendPositionOptions.BottomLegend)
        .allow(null),
});
const FontPropertiesSchema = Joi.object({
    __typename: Joi.string().valid('FontAttrs'),
    color: Joi.string().allow(null),
    bold: Joi.boolean().allow(null),
    italic: Joi.boolean().allow(null),
    strikeThrough: Joi.boolean().allow(null),
    underline: Joi.boolean().allow(null),
});
export const ConditionalFormatConfigSchemaV4dot2 = Joi.object({
    __typename: Joi.string().valid('ConditionalMetric'),
    operator: Joi.string()
        .valid(...Object.values(Operators))
        .allow(null),
    rangeValues: Joi.object({
        __typename: Joi.string().valid('Range'),
        min: Joi.number().unsafe(),
        max: Joi.number().unsafe(),
    }).allow(null),
    value: Joi.string().allow(null, ''),
    plotAsBand: Joi.boolean().allow(null),
    fontProperties: FontPropertiesSchema.allow(null),
    backgroundFormatType: Joi.string()
        .valid(...Object.values(BackgroundFormatTypes))
        .allow(null),
    gradientBackgroundAttrs: Joi.object({
        __typename: Joi.string().valid('GradientBackgroundAttrs'),
        backgroundFormatRange: Joi.array()
            .items(Joi.number().allow(null))
            .allow(null),
        backgroundFormatMidpoint: Joi.number()
            .unsafe()
            .allow(null),
        colors: Joi.array()
            .items(Joi.string().allow(null, ''))
            .allow(null),
    }).allow(null),
    solidBackgroundAttrs: Joi.object({
        __typename: Joi.string().valid('SolidBackgroundAttrs'),
        color: Joi.string().allow(null),
    }).allow(null),
    comparisonType: Joi.string()
        .valid(...Object.values(ConditionalFormattingComparisonTypes))
        .allow(null),
    lhsColumnId: Joi.string().allow(null),
    rhsColumnId: Joi.string().allow(null),
    comparisonParameterId: Joi.string().allow(null),
    isHighlightRow: Joi.boolean().allow(null),
});
const ColumnPropertiesSchema = Joi.object({
    __typename: Joi.string().valid('ChartVizColumnProperties'),
    dataLabels: Joi.boolean().allow(null),
    conditionalFormatting: Joi.object({
        __typename: Joi.string().valid('ConditionalFormatting'),
        rows: Joi.array().items(ConditionalFormatConfigSchemaV4dot2),
    }).allow(null),
    handleMissingValues: Joi.string()
        .valid(HandleMissingValues.DontShow, HandleMissingValues.ShowGap, HandleMissingValues.ShowAsZero)
        .allow(null),
    excludeNullValues: Joi.boolean().allow(null),
    customProps: Joi.string().allow(null),
});
const ColumnPropertiesSchemaV4Dot2 = Joi.object({
    __typename: Joi.string().valid('ChartColumnPropertyMap'),
    columnId: Joi.string(),
    columnProperty: ColumnPropertiesSchema,
});
const AxisPropertiesSchemaV4dot2 = Joi.array().items(Joi.object({
    __typename: Joi.string().valid('AxisObj'),
    id: Joi.string(),
    properties: AxisPropertiesSchema.keys({
        dynamicTitle: Joi.string().allow(null),
    }),
}));
class ClientStateV4dot2Class {
}
const ClientStateV4dot2Schema = Joi.object({
    ...ClientStateV4dot1Props,
    axisProperties: AxisPropertiesSchemaV4dot2,
    columnProperties: Joi.array().items(ColumnPropertiesSchemaV4Dot2),
    chartProperties: ChartPropertiesSchemaV4dot2,
    version: Joi.string().valid(ChartVizPropVersion.V4Dot2),
});
export { ClientStateV4dot2Class, ClientStateV4dot2Schema };
//# sourceMappingURL=v4dot2.js.map